import React from 'react'
// import { browserHistory } from 'react-router'
import './NotFound.less'

export default function NotFound() {
	return (
		<div className="notfound">
			<h1>Not Found</h1>
		</div>
	)
}



// WEBPACK FOOTER //
// ./src/components/404/NotFound.jsx